var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('common-acf-hero',{attrs:{"content":_vm.$store.state.wp.pageContent}}),_vm._v(" "),_c('v-container',_vm._l((_vm.resources),function(section,index){return _c('resources-section',{key:`section_${index}`,attrs:{"section":section}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }